module.exports = __webpack_public_path__ + "static/media/ambulance.c7b09cde.png";